const STRINGS_IT = {
    // --- APP & AUTH ---
    APP_TITLE: "AI MOX",
    AUTH_TITLE_EMAIL: "Login",
    AUTH_DESC_EMAIL: "Inserisci le tue credenziali",
    AUTH_PLACEHOLDER_EMAIL: "Username",
    AUTH_PLACEHOLDER_CODE: "Password",
    AUTH_BTN_LOGIN: "Accedi",
    AUTH_LOADING: "Accesso in corso...",
    AUTH_USER_INFO: "Autenticato come:",
    AUTH_BTN_LOGOUT: "Esci",
    AUTH_CONFIRM_LOGOUT: "Vuoi davvero uscire?",
    AUTH_ERROR_CODE_LENGTH: "Il codice deve essere di almeno 3 caratteri.",
    AUTH_ERROR_FAIL: "Errore di autenticazione, controllare username e password.",
    
    // --- CHAT LAYOUT ---
    CHAT_TITLE: "Agenti Attivi",
    CHAT_BTN_NEW: "Nuova Chat",
    CHAT_PLACEHOLDER_INPUT: "Immetti qui il tuo prompt per l'IA...",
    CHAT_BTN_SEND: "Invia",
    CHAT_TITLE_RECENT_RESPONSES: "Risposte Recenti",
    CHAT_TITLE_MAINTAINED_RESPONSES: "Risposte Mantenute",
    CHAT_PLACEHOLDER_EMPTY_HISTORY: "Nessuna chat attiva.",
    CHAT_RESPONSE_DELETE: "Cancella",
    CHAT_RESPONSE_COPY: "Copia",
    CHAT_RESPONSE_KEEP: "Mantieni",
    CHAT_BTN_RENAME: "Rinomina",
    CHAT_BTN_SAVE: "Salva",
    CHAT_MSG_COPY_SUCCESS: "Risposta copiata!",
    CHAT_LOADING: "In corso, attendi...",
    CHAT_SELECT_CHAT: "Seleziona una Chat",
    
    // --- ADMIN DASHBOARD ---
    ADMIN_TITLE: "Pannello di Controllo Amministrativo",
    ADMIN_TAB_DASHBOARD: "Dashboard",
    ADMIN_TAB_USERS: "Gestione Utenti",
    ADMIN_TAB_CHATS: "Gestione Chat",
    
    // User Management
    ADMIN_USERS_BTN_CREATE: "Crea Nuovo Utente",
    ADMIN_USERS_PROMPT_CREATE: "Inserisci il nome del nuovo utente:",
    ADMIN_USERS_CONFIRM_DELETE: "Sei sicuro di voler eliminare questo utente?",
    ADMIN_USERS_EDIT_TITLE: "Modifica Utente:",
    
    ADMIN_LABEL_NAME: "Nome",
    ADMIN_LABEL_SURNAME: "Cognome",
    ADMIN_LABEL_EMAIL: "Username",
    ADMIN_LABEL_PASSWORD: "Password",
    ADMIN_LABEL_PERMISSION: "Profilo",
    ADMIN_LABEL_MAX_CHAT: "Max Chat",
    ADMIN_LABEL_CREATE_CHAT: "Creazione Chat",
    ADMIN_LABEL_CUSTOM_CHAT: "Customizzazione Chat",
    
    ADMIN_BTN_CANCEL: "Annulla",
    ADMIN_BTN_SAVE_CHANGES: "Salva Modifiche",
    
    ADMIN_TABLE_HEADER_NAME: "Nome",
    ADMIN_TABLE_HEADER_STATUS: "Stato",
    ADMIN_TABLE_HEADER_MAX_CHAT: "Max Chat",
    ADMIN_TABLE_HEADER_PERMISSIONS: "Profilo",
    ADMIN_TABLE_HEADER_ACTIONS: "Azioni",
    
    ADMIN_STATUS_ACTIVE: "Attivo",
    ADMIN_STATUS_DISABLED: "Disabilitato",
    ADMIN_PERM_CREATE_YES: "Creaz. Si",
    ADMIN_PERM_CREATE_NO: "Creaz. No",
    ADMIN_PERM_CUSTOM_YES: "Custom. Si",
    ADMIN_PERM_CUSTOM_NO: "Custom. No",
    
    ADMIN_ACTION_MODIFY: "Modifica",
    ADMIN_ACTION_DISABLE: "Disabilita",
    ADMIN_ACTION_ENABLE: "Abilita",
    ADMIN_ACTION_DELETE_USER: "Elimina Utente",

    // Chat Management Admin
    ADMIN_CHATS_TITLE: "Gestione Chat Utenti",
    ADMIN_CHATS_BTN_CREATE_EMPTY: "Crea Chat Vuota",
    ADMIN_CHATS_CONFIRM_DELETE: "Sei sicuro di voler eliminare/ripristinare questa chat questa chat?",
    
    ADMIN_CHATS_HEADER_TITLE: "Titolo Chat",
    ADMIN_CHATS_HEADER_OWNER: "Proprietario",
    ADMIN_CHATS_HEADER_STATUS: "Stato",
    ADMIN_CHATS_HEADER_ACTIONS: "Azioni",
    
    ADMIN_CHATS_ACTION_DELETE: "Cancella Chat",
    ADMIN_CHATS_ACTION_EDIT: "Modifica Chat",

    // Config Forms (Chat)
    CHAT_CONFIG_FORM_TITLE: "Modifica Configurazione Chat",
    CHAT_CONFIG_LABEL_TITOLO: "Titolo Chat",
    CHAT_CONFIG_LABEL_STATO: "Stato",
    CHAT_CONFIG_LABEL_USERNAME: "Username (Proprietario)",
    CHAT_CONFIG_LABEL_CFGNAME: "Nome Configurazione RAG",
    CHAT_CONFIG_LABEL_CFGPROMPT: "Prompt di Configurazione",
    CHAT_CONFIG_LABEL_CFGSCHEMA: "Modello della catena di azioni",
    
    CHAT_CONFIG_FILES_ASSOCIATED: "Elenco dei File già Associati:",
    CHAT_CONFIG_UPLOAD_TITLE: "Gestione Documenti Associati",
    CHAT_CONFIG_UPLOAD_DESC: "Seleziona i file da caricare (PDF, MD, TXT). Questi verranno inviati alla tua API FastAPI.",
    CHAT_CONFIG_FILE_UPLOAD_BTN: "Aggiungi File",
    CHAT_CONFIG_FILE_LIST_TITLE: "File pronti per l'upload:",
    CHAT_CONFIG_FILE_LIST_EMPTY: "Nessun file selezionato.",
    CHAT_CONFIG_BTN_SAVE_CONFIG: "Salva Configurazione Chat",
    CHAT_CONFIG_BTN_UPLOAD_FILES: "Carica Documenti Selezionati",
    
    // Action Cards
    CARD_USERS_TITLE: "Gestione Utenti",
    CARD_USERS_DESC: "Crea, modifica permessi ed elimina utenti.",
    CARD_CHATS_DESC2: "Abilita/Disabilita interazione con chat.",
    CARD_CHATS_TITLE: "Gestione Chat",
    CARD_CHATS_DESC: "Visualizza, crea chat vuote e cancella chat esistenti.",

    USERS_CONFIG_LIST :"Utenti",
    USERS_CONFIG_LIST_EMPTY :"Nessu Utente",
};

const STRINGS_EN = {
    // --- APP & AUTH ---
    APP_TITLE: "AI MOX",
    AUTH_TITLE_EMAIL: "Login",
    AUTH_DESC_EMAIL: "Enter your credentials",
    AUTH_PLACEHOLDER_EMAIL: "Username",
    AUTH_PLACEHOLDER_CODE: "Password",
    AUTH_BTN_LOGIN: "Login",
    AUTH_LOADING: "Logging in...",
    AUTH_USER_INFO: "Logged in as:",
    AUTH_BTN_LOGOUT: "Logout",
    AUTH_CONFIRM_LOGOUT: "Do you really want to logout?",
    AUTH_ERROR_CODE_LENGTH: "Code must be at least 3 characters.",
    AUTH_ERROR_FAIL: "Authentication error, check username and password.",
    
    // --- CHAT LAYOUT ---
    CHAT_TITLE: "Active Agents",
    CHAT_BTN_NEW: "New Chat",
    CHAT_PLACEHOLDER_INPUT: "Enter your AI prompt here...",
    CHAT_BTN_SEND: "Send",
    CHAT_TITLE_RECENT_RESPONSES: "Recent Responses",
    CHAT_TITLE_MAINTAINED_RESPONSES: "Saved Responses",
    CHAT_PLACEHOLDER_EMPTY_HISTORY: "No active chats.",
    CHAT_RESPONSE_DELETE: "Delete",
    CHAT_RESPONSE_COPY: "Copy",
    CHAT_RESPONSE_KEEP: "Keep",
    CHAT_BTN_RENAME: "Rename",
    CHAT_BTN_SAVE: "Save",
    CHAT_MSG_COPY_SUCCESS: "Response copied!",
    CHAT_LOADING: "Processing, please wait...",
    CHAT_SELECT_CHAT: "Select a Chat",
    
    // --- ADMIN DASHBOARD ---
    ADMIN_TITLE: "Admin Control Panel",
    ADMIN_TAB_DASHBOARD: "Dashboard",
    ADMIN_TAB_USERS: "Users Management",
    ADMIN_TAB_CHATS: "Chats Management",
    
    // User Management
    ADMIN_USERS_BTN_CREATE: "Create New User",
    ADMIN_USERS_PROMPT_CREATE: "Enter new user name:",
    ADMIN_USERS_CONFIRM_DELETE: "Are you sure you want to delete this user?",
    ADMIN_USERS_EDIT_TITLE: "Edit User:",
    
    ADMIN_LABEL_NAME: "First Name",
    ADMIN_LABEL_SURNAME: "Last Name",
    ADMIN_LABEL_EMAIL: "Username",
    ADMIN_LABEL_PASSWORD: "Password",
    ADMIN_LABEL_PERMISSION: "Profile",
    ADMIN_LABEL_MAX_CHAT: "Max Chats",
    ADMIN_LABEL_CREATE_CHAT: "Create Chat",
    ADMIN_LABEL_CUSTOM_CHAT: "Customize Chat",
    
    ADMIN_BTN_CANCEL: "Cancel",
    ADMIN_BTN_SAVE_CHANGES: "Save Changes",
    
    ADMIN_TABLE_HEADER_NAME: "Name/Email",
    ADMIN_TABLE_HEADER_STATUS: "Status",
    ADMIN_TABLE_HEADER_MAX_CHAT: "Max Chats",
    ADMIN_TABLE_HEADER_PERMISSIONS: "Profile",
    ADMIN_TABLE_HEADER_ACTIONS: "Actions",
    
    ADMIN_STATUS_ACTIVE: "Active",
    ADMIN_STATUS_DISABLED: "Disabled",
    ADMIN_PERM_CREATE_YES: "Create Yes",
    ADMIN_PERM_CREATE_NO: "Create No",
    ADMIN_PERM_CUSTOM_YES: "Custom Yes",
    ADMIN_PERM_CUSTOM_NO: "Custom No",
    
    ADMIN_ACTION_MODIFY: "Edit",
    ADMIN_ACTION_DISABLE: "Disable",
    ADMIN_ACTION_ENABLE: "Enable",
    ADMIN_ACTION_DELETE_USER: "Delete User",

    // Chat Management Admin
    ADMIN_CHATS_TITLE: "User Chat Management",
    ADMIN_CHATS_BTN_CREATE_EMPTY: "Create Empty Chat",
    ADMIN_CHATS_CONFIRM_DELETE: "Are you sure you want to delete/restore this chat?",
    
    ADMIN_CHATS_HEADER_TITLE: "Chat Title",
    ADMIN_CHATS_HEADER_OWNER: "Owner",
    ADMIN_CHATS_HEADER_STATUS: "Status",
    ADMIN_CHATS_HEADER_ACTIONS: "Actions",
    
    ADMIN_CHATS_ACTION_DELETE: "Delete Chat",
    ADMIN_CHATS_ACTION_EDIT: "Edit Chat",

    // Config Forms (Chat)
    CHAT_CONFIG_FORM_TITLE: "Edit Chat Configuration",
    CHAT_CONFIG_LABEL_TITOLO: "Chat Title",
    CHAT_CONFIG_LABEL_STATO: "Status",
    CHAT_CONFIG_LABEL_USERNAME: "Username (Owner)",
    CHAT_CONFIG_LABEL_CFGNAME: "RAG Config Name",
    CHAT_CONFIG_LABEL_CFGPROMPT: "Config Prompt",
    
    
    CHAT_CONFIG_FILES_ASSOCIATED: "Already Associated Files:",
    CHAT_CONFIG_UPLOAD_TITLE: "Manage Associated Documents",
    CHAT_CONFIG_UPLOAD_DESC: "Select files to upload (PDF, MD, TXT).",
    CHAT_CONFIG_FILE_UPLOAD_BTN: "Add File",
    CHAT_CONFIG_FILE_LIST_TITLE: "Files ready for upload:",
    CHAT_CONFIG_FILE_LIST_EMPTY: "No files selected.",
    CHAT_CONFIG_BTN_SAVE_CONFIG: "Save Chat Config",
    CHAT_CONFIG_BTN_UPLOAD_FILES: "Upload Selected Documents",
    
    // Action Cards
    CARD_USERS_TITLE: "Users Management",
    CARD_USERS_DESC: "Create, modify permissions, and delete users.",
    CARD_CHATS_DESC2: "Enable/disable chat interactions.",
    CARD_CHATS_TITLE: "Chats Management",
    CARD_CHATS_DESC: "View, create, and delete chats.",

    USERS_CONFIG_LIST :"Users",
    USERS_CONFIG_LIST_EMPTY :"No users",
};

const LANG = (lang) => {
    if (lang === 'en') return STRINGS_EN;
    return STRINGS_IT;
}

export default LANG;